export default "__VITE_ASSET__DZxUw9au__"